import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { api } from '../../lib/api.ts'
import { portasDeEntrada } from './portas-de-entrada.ts'

/**
 * Etapas oferecidas quando um item está NASCENDO: as PORTAS DE ENTRADA de
 * cada fluxo de que o tipo participa (regra em `portas-de-entrada.ts`).
 *
 * Regra do usuário (2026-08-30): um item que ainda vai nascer — e um modelo,
 * que nunca "andou" — só pode começar por onde o fluxo deixa entrar. Nada de
 * escolher uma etapa do meio nem de seguir a condução.
 *
 * Quantas portas existem é decisão de quem desenhou o fluxo: o desenho marca
 * "pode iniciar por esta etapa" e todas as marcadas são oferecidas.
 *
 * Vive num arquivo próprio porque vale em mais de um lugar: o diálogo de
 * "Converter em item" e o editor de template de checklist usam a mesma regra.
 */
export type EtapaInicial = { flowStepId: string; flowName: string; stepName: string }

export function useEtapasIniciais(
  typeId: string | null | undefined,
  tipos: readonly { id: string }[],
): EtapaInicial[] {
  const flowNodes = useQuery({
    queryKey: ['flow-nodes'],
    queryFn: async () => (await api.flows.nodes.$get()).json(),
    retry: false,
  })
  const nos = flowNodes.data?.nodes ?? []
  const ligacoes = flowNodes.data?.transitions ?? []

  return useMemo(() => {
    if (!typeId) return []
    const doTipo = ((tipos.find((x) => x.id === typeId) as { flowIds?: string[] } | undefined)?.flowIds) ?? []
    if (doTipo.length === 0) return []
    return portasDeEntrada(nos, ligacoes, doTipo)
  }, [typeId, nos, ligacoes, tipos])
}
